export interface MasonryPosition {
  x: number;
  y: number;
  column: number;
}

export interface MasonryLayout {
  positions: MasonryPosition[];
  /** 가장 긴 열의 높이. 마지막 카드 아래 간격은 포함하지 않는다. */
  height: number;
}

/**
 * 카드를 API 순서대로 한 장씩, 지금까지 누적 높이가 가장 짧은 열에 놓는다. 높이가 같으면 왼쪽 열이 먼저다.
 *
 * 앞 카드들의 높이가 그대로면 뒤에 카드를 더해도 앞 카드의 자리는 바뀌지 않는다.
 * 그래서 무한 스크롤로 카드를 이어 붙일 때 전체를 다시 계산해도 기존 카드가 열 사이를 옮겨 다니지 않는다.
 */
export const computeMasonryLayout = (
  heights: number[],
  columnCount: number,
  columnWidth: number,
  gap: number,
): MasonryLayout => {
  const columns = Math.max(1, Math.floor(columnCount));
  const columnHeights = new Array<number>(columns).fill(0);
  const positions: MasonryPosition[] = [];

  for (const height of heights) {
    let column = 0;
    for (let index = 1; index < columns; index += 1) {
      if (columnHeights[index] < columnHeights[column]) column = index;
    }

    positions.push({
      x: column * (columnWidth + gap),
      y: columnHeights[column],
      column,
    });
    columnHeights[column] += Math.max(0, height) + gap;
  }

  const tallest = Math.max(...columnHeights);

  return {
    positions,
    height: heights.length === 0 ? 0 : Math.max(0, tallest - gap),
  };
};
